/**
 * /messages/$conversationId (index) — null component.
 *
 * Phase 4a placeholder; the thread Outlet (`t/$parentId`) ships in 4e.
 * The conversation pane is fully rendered by the parent `route.tsx`, so
 * this index file just renders nothing.
 */

import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/messages/$conversationId/')({
  component: () => null,
})
